import PageHero from "@/components/PageHero";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const CATS = ["All", "Campaigns", "Events", "Meetings"];

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("All");
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const filtered = tab === "All" ? items : items.filter((i) => i.category === tab);

  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="Gallery" title="Moments from the movement." subtitle="Campaigns, events, and meetings — captured." />
      <section className="section-y">
        <div className="container-x">
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="bg-[hsl(var(--bg-muted))] rounded-none mb-10">
              {CATS.map((c) => (
                <TabsTrigger key={c} value={c} data-testid={`gallery-tab-${c}`}
                  className="rounded-none uppercase text-xs tracking-widest data-[state=active]:bg-[hsl(var(--primary))] data-[state=active]:text-white">
                  {c}
                </TabsTrigger>
              ))}
            </TabsList>
            <TabsContent value={tab}>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {filtered.map((g) => (
                  <figure key={g.id} className="aspect-square overflow-hidden bg-[hsl(var(--bg-muted))] group" data-testid={`gallery-img-${g.id}`}>
                    <img src={g.image_url} alt={g.title} loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </figure>
                ))}
                {filtered.length === 0 && <div className="text-[hsl(var(--fg-muted))]">No images in this category.</div>}
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </section>
    </div>
  );
}
